









































































































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import UUIFComponents from '@/shared/uuifComponent';
import { SwModal } from '@sonicwall/unified-ui-framework/src/shared/sw-modal';
import { MswApiService } from '@/shared/msw-api-service';

const cssPrefix = 'preference-migration-modal';

@Component({
  components: {
    ...UUIFComponents,
    SwModal,
  },
})
export default class PreferenceMigrationModal extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @Prop({ type: Boolean, default: false })
  showModal: boolean;

  @Prop({ type: Boolean, default: false })
  isSuperAdmin: boolean;

  isVisible: boolean = false;

  @Watch('showModal', { immediate: true })
  onShowModalChange(newVal: boolean) {
    this.isVisible = newVal;
  }

  onClose() {
    this.isVisible = false;
    this.$emit('closeModal');
  }

  onLearnMore() {
    window.open('https://www.sonicwall.com/support/knowledge-base/kA1VN000001Hb2b0AC', '_blank');
  }

  async handleOptIn() {
    try {
      this.$store.commit('startLoading');
      const response = await MswApiService.tenant.updateBackupChoices({
        isUpdateBackUpChoice: 'YES',
        isCloudBackupRemindMe: 'NO',
        isCloudAcknowledge: 'YES',
        isCloudBackupDontShowAgain: 'NO',
      });

      if (response.operationStatus === 'OK') {
        this.isVisible = false;
        this.$emit('closeModal', 'opted-in');
        this.setConfirmed();
      } else {
        this.$store.commit('enqueueMessage', {
          infoType: 'failed',
          infoMsg: response.msgDesc || this.$t('workflow.dashboard.prefMigration.error'),
        });
      }
    } catch (error) {
      this.$store.commit('enqueueMessage', {
        infoType: 'failed',
        infoMsg: (error as any)?.msgDesc || this.$t('workflow.dashboard.prefMigration.error'),
      });
    } finally {
      this.$store.commit('stopLoading');
    }
  }

  async handleRemindLater() {
    try {
      this.$store.commit('startLoading');
      const response = await MswApiService.tenant.updateBackupChoices({
        isUpdateBackUpChoice: 'YES',
        isCloudBackupRemindMe: 'YES',
        isCloudAcknowledge: 'NO',
        isCloudBackupDontShowAgain: 'NO',
      });

      if (response.operationStatus === 'OK') {
        this.$store.commit('enqueueMessage', {
          infoType: 'success',
          infoMsg: response.msgDesc || this.$t('workflow.dashboard.prefMigration.remindLaterSuccess'),
        });
        this.isVisible = false;
        this.$emit('closeModal', 'remind-later');
        this.setConfirmed();
      } else {
        this.$store.commit('enqueueMessage', {
          infoType: 'failed',
          infoMsg: response.msgDesc || this.$t('workflow.dashboard.prefMigration.error'),
        });
      }
    } catch (error) {
      this.$store.commit('enqueueMessage', {
        infoType: 'failed',
        infoMsg: (error as any)?.msgDesc || this.$t('workflow.dashboard.prefMigration.error'),
      });
    } finally {
      this.$store.commit('stopLoading');
    }
  }

  async handleDontShowAgain() {
    try {
      this.$store.commit('startLoading');
      const response = await MswApiService.tenant.updateBackupChoices({
        isUpdateBackUpChoice: 'NO',
        isCloudBackupRemindMe: 'NO',
        isCloudAcknowledge: 'NO',
        isCloudBackupDontShowAgain: 'YES',
      });

      if (response.operationStatus === 'OK') {
        this.isVisible = false;
        this.$emit('closeModal', 'dont-show-again');
        this.setConfirmed();
      } else {
        this.$store.commit('enqueueMessage', {
          infoType: 'failed',
          infoMsg: response.msgDesc || this.$t('workflow.dashboard.prefMigration.error'),
        });
      }
    } catch (error) {
      this.$store.commit('enqueueMessage', {
        infoType: 'failed',
        infoMsg: (error as any)?.msgDesc || this.$t('workflow.dashboard.prefMigration.error'),
      });
    } finally {
      this.$store.commit('stopLoading');
    }
  }

  async handleAcknowledge() {
    try {
      this.$store.commit('startLoading');
      const response = await MswApiService.tenant.updateBackupChoices({
        isUpdateBackUpChoice: 'YES',
        isCloudBackupRemindMe: 'NO',
        isCloudAcknowledge: 'YES',
        isCloudBackupDontShowAgain: 'NO',
      });

      if (response.operationStatus === 'OK') {
        this.$store.commit('enqueueMessage', {
          infoType: 'success',
          infoMsg: response.msgDesc || this.$t('workflow.dashboard.prefMigration.acknowledgeSuccess'),
        });
        this.isVisible = false;
        this.$emit('closeModal', 'acknowledged');
        this.setConfirmed();
      } else {
        this.$store.commit('enqueueMessage', {
          infoType: 'failed',
          infoMsg: response.msgDesc || this.$t('workflow.dashboard.prefMigration.error'),
        });
      }
    } catch (error) {
      this.$store.commit('enqueueMessage', {
        infoType: 'failed',
        infoMsg: (error as any)?.msgDesc || this.$t('workflow.dashboard.prefMigration.error'),
      });
    } finally {
      this.$store.commit('stopLoading');
    }
  }

  setConfirmed() {
    try {
      sessionStorage.setItem('isMigrationAccepted', 'YES');
    } catch (e) {
      console.error(e);
    }
  }
}
